import cs_1 from 'date-fns/locale/cs';

const dateCs = {
	name: 'cs-CZ',
	locale: cs_1,
};
export default dateCs;
